module.exports = __webpack_public_path__ + "img/tattoo16.ae89308c.jpg";